export var printTemplate = /\$([\w.]+)/g;


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/utils/print.js
// module id = pK69
// module chunks = 3